// extracted by mini-css-extract-plugin
export default {"customDescriptionItem":"descriptions_customDescriptionItem__R2k2t","customDescriptionSystem":"descriptions_customDescriptionSystem__TyMiY"};